<template>
  <el-container direction="vertical">
    <Header />
    <router-view />
  </el-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/public/Header.vue";
export default {
  name: "app",
  components: {
    Header
  },
  created() {
    /**初始化字典 */
    // this.getDicts();
  },
  computed: {
    ...mapGetters(["dictAll", "dict"])
  },
  methods: {
    ...mapActions(["getDicts"])
  }
};
</script>
<style lang="scss">
html,
body {
  height: 100%;
}
.el-form-item {
  .form_item_info {
    input,
    textarea,
    .el-input-group__append,
    .el-input-group__prepend {
      border: none;
      font-weight: bold;
      color: #333;
      background: transparent;
    }
  }
}
.game_info {
  border: none;
  font-weight: bold;
  color: #333;
  background: transparent;
  padding: 0 0.9375rem;
  font-size: 0.8125rem;
}
.main_container .main_panel.qssComponent {
  border: none !important;
  box-shadow: none !important;
}
.main_container .main_panel.qssComponent .content_panel {
  padding: 0 !important;
}
.main_container .main_panel.qssComponent .content_panel .search_panel {
  padding-top: 0 !important;
}
.el-table--border th:first-child.el-table-column--selection .cell,
.el-table--border td:first-child.el-table-column--selection .cell {
  padding-left: 0.875rem;
}
.el-table__body-wrapper {
  min-height: calc(100% - 41px);
}
/* 处理火狐下的兼容问题 */
.el-table {
  .el-table__fixed-left,
  .el-table__fixed-right {
    height: auto !important; // 此处的important表示优先于element.style
    bottom: 17px; // 改为自动高度后，设置与父容器的底部距离，则高度会动态改变
    &::before {
      background-color: transparent;
    }
  }
}
</style>
